import './Layout.css';
export default {
    "wrapper": "Layout_wrapper__1mtzl",
    "headWrapper": "Layout_headWrapper__1mtzl",
    "title": "Layout_title__1mtzl",
    "viewAll": "Layout_viewAll__1mtzl",
    "itemList": "Layout_itemList__1mtzl",
    "rightArrow": "Layout_rightArrow__1mtzl",
    "leftArrow": "Layout_leftArrow__1mtzl"
};
